<template>
  <OurViewport class="static-layout">
    <OurTopLoader v-if="!isRenderingPage" z-index="50" />

    <OurNotify />

    <main class="main">
      <div class="flex items-center justify-between">
        <OurLogo size="3xl" :path="logoPath" />
        <div class="flex gap-3">
          <OurButton
            variant="secondary"
            :text="$t('button.back')"
            size="md"
            @click="goToRegistration"
          />
          <OurButton :text="$t('title.login')" size="md" @click="goToLogin" />
        </div>
      </div>

      <div class="view-wrap">
        <router-view />
      </div>
    </main>
  </OurViewport>
</template>

<script>
import { getTheme, isPWA, removeOutlineFocus } from "@/services/_bit/UiService";
import { mapGetters, mapState } from "vuex";

import OurViewport from "@/layouts/_bit/_components/Viewport";
import OurLogo from "@/components/_bit/Logo";
import OurNotify from "@/layouts/_bit/_components/Notify";
import OurTopLoader from "@/layouts/_bit/_components/LoaderTop";

export default {
  name: "StaticLayout",

  components: {
    OurViewport,
    OurLogo,
    OurNotify,
    OurTopLoader,
  },

  data() {
    return {
      isHiddenFeatures: true,
    };
  },

  computed: {
    ...mapState("loader", ["isRenderingPage"]),

    ...mapGetters("user", ["backgroundImage"]),

    routeName() {
      return this.$route.name;
    },

    logoPath() {
      return "static/logos/dark-outline.svg";
    },
  },

  created() {
    this.setBodyBg();

    removeOutlineFocus();
  },

  methods: {
    setBodyBg() {
      const body = document.querySelector("body");
      const theme = getTheme();
      const bodyClass = theme ? `theme-bg-${theme}` : "theme-bg-default";

      if (isPWA) {
        const bodyPWAClass = `${bodyClass}-pwa`;

        body.classList.add(bodyPWAClass);
      }

      body.classList.add(bodyClass);
    },
    goToLogin() {
      this.$router.push("login");
    },
    goToRegistration() {
      this.$router.push("registration");
    },
  },
};
</script>

<style lang="postcss">
.theme-bg {
  &-default {
    @apply bg-gray-900;
  }
}
</style>

<style lang="postcss" scoped>
.static-layout {
  @apply flex min-h-screen md:p-2;
  @apply bg-gray-900;

  &-wrapper {
    @apply flex items-center justify-between;
  }

  .main {
    @apply flex w-full flex-col;
    @apply rounded-none p-6 md:rounded-lg;
    @apply bg-gray-50 !bg-cover bg-fixed bg-center;

    .view-wrap {
      @apply w-full py-10;
    }
  }
}

.pwa-layout {
  -webkit-user-select: none;
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;

  .main {
    @apply fixed inset-0 h-full overflow-auto;
    @apply rounded-t-2xl;
  }
}
</style>
